import React from "react";
import dataAbout from "../../../data.json";

const About = () => {
	return (
		<section className="text-center" data-bg-img="images/pattern/01.png" id="development">
			<div className="container wow fadeInUp">
				<div className="row">
					<div className="col-lg-10 col-md-12 ml-auto mr-auto">
						<h3 className="text-black font-weight-bold line-h-2">
							The{" "}
							<span className="text-theme">Sureze HIS</span> is built for
							you. With an <span className="text-theme">intuitive interface</span>,{" "}
							<span className="text-theme">efficient data management,</span>{" "}
							it leverages your data to provide the best patient care experience 
							while maximizing revenue.
						</h3>
					</div>
				</div>
				<div className="row text-left">
					{dataAbout.data.services[0].about.features.map(
						(feature, index) => (
							<div className="col-lg-4 col-md-6 mt-5" key={index}>
								<div className="featured-item style-6">
									<div className="featured-icon">
										<i className={`${feature["icon"]}`}></i>
										<span className="rotateme"></span>
									</div>
									<div className="featured-title">
										<h4 className="font-weight-bold">{feature["title"]}</h4>
									</div>
									<div className="featured-desc">
										<p className="font-weight-bold">{feature["description"]}</p>
									</div>
								</div>
							</div>
						)
					)}
				</div>
			</div>
		</section>
	);
};

export default About;
